/**
 * Turns the mandalas as the page scrolls.
 *
 * One shared animation loop moves only the mandala elements (never a page-wide CSS
 * variable, which would make the browser re-style the whole page on every frame), and it
 * eases towards the scroll position using real elapsed time, so it stays smooth on
 * 60, 90 and 120 Hz screens and when a mouse wheel scrolls in big steps.
 */
const DEGREES_PER_PIXEL = 0.045;
const EASE = 0.16;            // share of the remaining distance covered per 1/60 s

const items = new Set();
let target = 0;
let current = 0;
let raf = 0;
let last = 0;
let bound = false;

const paint = () => {
  items.forEach(({ el, dir }) => { el.style.transform = `rotate(${(current * dir).toFixed(3)}deg)`; });
};

const frame = (now) => {
  const dt = Math.min(64, now - last || 16.7);
  last = now;
  current += (target - current) * (1 - Math.pow(1 - EASE, dt / 16.67));
  if (Math.abs(target - current) < 0.005) { current = target; raf = 0; } else raf = requestAnimationFrame(frame);
  paint();
};

const onScroll = () => {
  target = window.scrollY * DEGREES_PER_PIXEL;
  if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); }
};

/** Start turning `el` (dir 1 = clockwise, -1 = anticlockwise). Returns a stop function. */
export function registerTurn(el, dir = 1) {
  if (!el || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return undefined;
  const item = { el, dir };
  items.add(item);
  if (!bound) { window.addEventListener('scroll', onScroll, { passive: true }); bound = true; }
  if (!raf) current = target = window.scrollY * DEGREES_PER_PIXEL;
  paint();
  return () => {
    items.delete(item);
    if (!items.size) { window.removeEventListener('scroll', onScroll); bound = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
  };
}
